import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import Header from './Header'
import Sidebar from './Sidebar'
import AppBottomNavigation from './AppBottomNavigation'
import PageContent from './PageContent'
import { SessionManager } from '@components/SessionManager'
import SystemAnnouncementBanner from '@components/notifications/SystemAnnouncementBanner'
import ShellBottomAlertStack from './ShellBottomAlertStack'
import { ShellOverlayMetricsProvider } from './ShellOverlayMetricsProvider'
import { DRAWER_WIDTH } from './layoutConstants'
import { useAppShellDrawerState } from './useAppShellDrawer'
import { appMainWithHeaderOffsetSx } from './mainContentStyles'
import { useFeatureUseRouteTracking } from '@hooks/useFeatureUseRouteTracking'
import { SmokingSessionRuntimeProvider } from '@/contexts/SmokingSessionRuntimeContext'
import MiniSessionBar from '@components/sessions/MiniSessionBar'

const Layout: React.FC = () => {
  const { mobileOpen, toggleMobileDrawer, closeMobileDrawer, isTemporaryDrawer } =
    useAppShellDrawerState()

  useFeatureUseRouteTracking()

  return (
    <SessionManager>
      <SmokingSessionRuntimeProvider>
      <ShellOverlayMetricsProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar
          mobileOpen={mobileOpen}
          onMobileClose={closeMobileDrawer}
        />
        <Box
          data-testid="app-main-column"
          data-shell-mode={isTemporaryDrawer ? 'temporary' : 'permanent'}
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            width: isTemporaryDrawer ? '100%' : `calc(100% - ${DRAWER_WIDTH}px)`,
          }}
        >
          <Header
            showMenuButton={isTemporaryDrawer}
            onMenuToggle={toggleMobileDrawer}
            menuOpen={mobileOpen}
          />
          <Box component="main" sx={appMainWithHeaderOffsetSx()}>
            <SystemAnnouncementBanner />
            <PageContent>
              <Outlet />
            </PageContent>
          </Box>
          <ShellBottomAlertStack />
          <MiniSessionBar />
          <AppBottomNavigation />
        </Box>
      </Box>
      </ShellOverlayMetricsProvider>
      </SmokingSessionRuntimeProvider>
    </SessionManager>
  )
}

export default Layout
